import { render, staticRenderFns } from "./Gg.vue?vue&type=template&id=f479574e&scoped=true"
import script from "./Gg.vue?vue&type=script&lang=js"
export * from "./Gg.vue?vue&type=script&lang=js"
import style0 from "./Gg.vue?vue&type=style&index=0&id=f479574e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f479574e",
  null
  
)

export default component.exports